import React, { createContext, useContext, useState } from "react";

const ResultContext = createContext();
const baseUrl = "https://google-search3.p.rapidapi.com/api/v1"


export const ResultContextProvider = ({children}) => { //children is a prop that every single react component has
    const [results, setResults] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState("Fenne Lily")

    //GetResult func.. is gonna be an async func cos we wanna make some api call. type ie..type of result.. /videos, /images etc
    const getResults = async (type) => {
        setIsLoading(true)
        const response = await fetch(`${baseUrl}${type}`, {
            method: "GET",
            headers: {  //copied from rapid api
                'x-user-agent': 'desktop',
                'x-rapidapi-host': 'google-search3.p.rapidapi.com',
                'x-rapidapi-key': process.env.REACT_APP__API_KEY,
            }
        })
        const data = await response.json()
        console.log(data)
        if (type.includes('/news')){
            setResults (data.entries);
        } else if (type.includes('/images')){
            setResults (data.image_results);
        } else {
            setResults (data.results);
        }

        setIsLoading(false)
    }
    return (
        <ResultContext.Provider value={{getResults, results, isLoading, searchTerm, setSearchTerm}}>
            {children}
        </ResultContext.Provider>
    )
}


export const useResultContext = () => useContext(ResultContext);
